export class FetchUserContainerByKcidAction {
  static readonly type = '[Container] Fetch User Containers by KcId';

  constructor(public kcId: string) {
  }
}
